var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "exam-page" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("h1", { staticClass: "page-title" }, [_vm._v("📝 在线答题")]),
      _vm._v(" "),
      _c("p", { staticClass: "page-subtitle" }, [
        _vm._v("共 " + _vm._s(_vm.exam_list.length) + " 道题目")
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "question-container" },
      _vm._l(_vm.exam_list, function(item, index) {
        return _c(
          "div",
          {
            key: item.Id,
            staticClass: "question-card",
            style: { animationDelay: index * 0.05 + "s" }
          },
          [
            _c("div", { staticClass: "question-header" }, [
              _c("span", { staticClass: "question-number" }, [
                _vm._v(_vm._s(index + 1))
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "question-type",
                  class: _vm.getTypeClass(item.TopicType)
                },
                [_vm._v("\n          " + _vm._s(item.TopicType) + "\n        ")]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "question-title" }, [
              _vm._v("\n        " + _vm._s(item.TopicName) + "\n        "),
              item.Category === 0 && _vm.ShowRightAnswer_ex
                ? _c("span", { staticClass: "correct-answer" }, [
                    _vm._v(
                      "\n          （正确答案：" +
                        _vm._s(item.IsRightAnswer) +
                        "）\n        "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            item.TopicType === "单选题"
              ? _c(
                  "div",
                  { staticClass: "options-list" },
                  [
                    _c(
                      "van-radio-group",
                      {
                        model: {
                          value: item.Answer,
                          callback: function($$v) {
                            _vm.$set(item, "Answer", $$v)
                          },
                          expression: "item.Answer"
                        }
                      },
                      _vm._l(item.TopicAnswerList, function(option) {
                        return _c(
                          "div",
                          {
                            key: option.Id,
                            staticClass: "option-item",
                            class: {
                              "option-selected": item.Answer === option.Number
                            },
                            on: {
                              click: function($event) {
                                item.Answer = option.Number
                              }
                            }
                          },
                          [
                            _c(
                              "van-radio",
                              {
                                attrs: {
                                  name: option.Number,
                                  "checked-color": "#d51900"
                                }
                              },
                              [
                                _c("span", { staticClass: "option-text" }, [
                                  _vm._v(_vm._s(option.Option))
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            item.TopicType === "多选题"
              ? _c(
                  "div",
                  { staticClass: "options-list" },
                  [
                    _c(
                      "van-checkbox-group",
                      {
                        model: {
                          value: item.Answer,
                          callback: function($$v) {
                            _vm.$set(item, "Answer", $$v)
                          },
                          expression: "item.Answer"
                        }
                      },
                      _vm._l(item.TopicAnswerList, function(option) {
                        return _c(
                          "div",
                          {
                            key: option.Id,
                            staticClass: "option-item",
                            class: {
                              "option-selected":
                                item.Answer &&
                                item.Answer.includes(option.Number)
                            }
                          },
                          [
                            _c(
                              "van-checkbox",
                              {
                                attrs: {
                                  name: option.Number,
                                  "checked-color": "#d51900",
                                  shape: "square"
                                }
                              },
                              [
                                _c("span", { staticClass: "option-text" }, [
                                  _vm._v(_vm._s(option.Option))
                                ])
                              ]
                            )
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            item.TopicType === "填空题"
              ? _c(
                  "div",
                  { staticClass: "fill-blank" },
                  [
                    _c("van-field", {
                      staticClass: "fill-input",
                      attrs: {
                        rows: "3",
                        autosize: "",
                        type: "textarea",
                        placeholder: "请输入您的答案"
                      },
                      model: {
                        value: item.Answer,
                        callback: function($$v) {
                          _vm.$set(item, "Answer", $$v)
                        },
                        expression: "item.Answer"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "submit-section" },
      [
        _c(
          "van-button",
          {
            staticClass: "submit-btn",
            attrs: {
              round: "",
              block: "",
              type: "info",
              loading: _vm.BTN_IF,
              "loading-text": "提交中..."
            },
            on: { click: _vm.submit }
          },
          [_vm._v("\n      提交答案\n    ")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-03525347", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03525347","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/examination.vue
// module id = null
// module chunks = 